import * as Sentry from '@sentry/react';
import { addBillingDiagnostics } from './billing-diagnostics';
import { BILLING_TELEMETRY_HEADER, parseBillingTelemetry } from './billing-telemetry-context';

/** Share existing browser diagnostics only with same-origin Billing handlers. */
export function billingTelemetryHeaders(uri) {
    const url = new URL(uri, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/api/')) return {};
    const tags = {
        ...Sentry.getGlobalScope().getScopeData().tags,
        ...Sentry.getIsolationScope().getScopeData().tags,
        ...Sentry.getCurrentScope().getScopeData().tags,
    };
    const diagnostics = addBillingDiagnostics({ tags });
    return {
        [BILLING_TELEMETRY_HEADER]: JSON.stringify(
            parseBillingTelemetry(JSON.stringify(diagnostics)),
        ),
    };
}
